import React, { useEffect, useMemo, useState } from 'react'
import { Alert, Button, Card } from 'react-bootstrap'

import { BASE } from '../../basedata/constants'
import { fetchWithApiKey } from '../../config/apiCall'
import { getCurrentCompanyProfile, getSelectedCompanySlug } from '../../config/session'

interface Props {
  onResponse: (response: any) => void
}

const CATARINA_SLUGS = ['catarina', 'catarinaaviationshow']

const buildQrServerUrl = (data: string, color = '000000') =>
  `https://api.qrserver.com/v1/create-qr-code/?size=300x300&bgcolor=ffffff&color=${color}&data=${encodeURIComponent(data)}`

const QrCode = ({ onResponse }: Props) => {

  const [qrData, setQrData] = useState('')
  const [showOnboardingQr, setShowOnboardingQr] = useState(false)
  const [copyMessage, setCopyMessage] = useState('')

  const ticketNumber = sessionStorage.getItem('ticket')
  const tokenBiometric = `${sessionStorage.getItem('tokenBiometric') || ''}`.trim()
  const companySlug = getSelectedCompanySlug()
  const companyProfile = getCurrentCompanyProfile()
  const canShowOnboardingQr = CATARINA_SLUGS.includes(companySlug) || CATARINA_SLUGS.includes(companyProfile.slug)
  const onboardingLink = useMemo(() => {
    if (!tokenBiometric || tokenBiometric === '-') {
      return ''
    }

    return `https://${companyProfile.slug}.bepass.com.br?token=${encodeURIComponent(tokenBiometric)}&source=dashboard`
  }, [companyProfile.slug, tokenBiometric])
  const onboardingQrData = onboardingLink ? buildQrServerUrl(onboardingLink, '143d2c') : ''

  const getQrCode = () => {
    fetchWithApiKey(`${BASE.ticket_api.base_url}${BASE.ticket_api.getQrCode}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        ticketNumber: ticketNumber
      })
    })
      .then((res) => res.json())
      .then((response) => {
        setQrData(response.qr)
        sessionStorage.removeItem('ticket')
        sessionStorage.removeItem('usedTicket')

      })
      .catch((error) => {
        alert('não foi possível gerar o ingresso')
        console.log(error)
      })
  }

  const copyOnboardingLink = async () => {
    if (!onboardingLink) return

    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(onboardingLink)
      } else {
        const textarea = document.createElement('textarea')
        textarea.value = onboardingLink
        textarea.setAttribute('readonly', '')
        textarea.style.position = 'fixed'
        textarea.style.left = '-9999px'
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
      }

      setCopyMessage('Link copiado')
      setTimeout(() => setCopyMessage(''), 2000)
    } catch (error) {
      console.log('Nao foi possivel copiar o link de onboarding', error)
      setCopyMessage('Não foi possível copiar. Use o link abaixo.')
    }
  }



  useEffect(() => {
    getQrCode()
  }, [])
  return (

    <Card>
      <Card.Header>
        <Card.Title as="h5"
          onClick={() => onResponse(0)}>
          <i className="feather icon-arrow-left"></i> Início
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <div className={`game-qr ${showOnboardingQr ? 'game-qr-onboarding' : ''}`}>
          {showOnboardingQr ? (
            <>
              <div className='onboarding-qr-label'>Onboarding biométrico</div>
              {onboardingQrData ? (
                <>
                  <img src={onboardingQrData} alt='QR Code de onboarding biométrico' />
                  <div className='onboarding-link-actions'>
                    <a href={onboardingLink} target='_blank' rel='noreferrer'>
                      {onboardingLink}
                    </a>
                    <Button variant='outline-primary' onClick={copyOnboardingLink}>
                      Copiar link
                    </Button>
                    {copyMessage && (
                      <span className='onboarding-copy-feedback'>{copyMessage}</span>
                    )}
                    <Button variant='link' onClick={() => setShowOnboardingQr(false)}>
                      Voltar para QR Code da contingência
                    </Button>
                  </div>
                </>
              ) : (
                <Alert variant='warning' className='onboarding-qr-alert'>
                  Não foi possível montar o link de onboarding para este usuário.
                </Alert>
              )}
            </>
          ) : (
            <>
              <img src={qrData} alt='QR Code de contingência' />
              {canShowOnboardingQr && (
                <div className='onboarding-entrypoint'>
                  <Button
                    variant='outline-primary'
                    disabled={!onboardingLink}
                    onClick={() => setShowOnboardingQr(true)}
                  >
                    Gerar QR Code de onboarding biométrico
                  </Button>
                  {!onboardingLink && (
                    <span>Link de onboarding indisponível para este usuário.</span>
                  )}
                </div>
              )}
            </>
          )}
        </div>
      </Card.Body>
    </Card>

  )
}

export default QrCode
